module.exports = __webpack_public_path__ + "static/media/채용 및 통합.8e1101f7.png";